module.exports = __webpack_public_path__ + "media/images/info_box_blue-456acef531a41862244b3e7891b8def3.svg";